import React, { useContext } from 'react';
import { Link, useLocation } from 'react-router-dom';
import NavbarContext from '../../context/navbar/navbarContext';
import './header.css';
import Burger from './Burger';


const Navbar = () => {
    const navbarContext = useContext(NavbarContext);
    const { nav, toggleNav } = navbarContext;

    const location = useLocation();

    return (
        <header>
            <nav className="container">
                <div id="logo">
                    <Link to="/">
                        <span style={{fontSize: '1.4em'}} ><span  className='text-danger'>Shift</span>Mindset</span>
                    </Link>
                </div>
                <ul className={`nav-links ${nav && 'nav-active'}`}>
                    <li><Link onClick={toggleNav} className={`${'/' === location.pathname && 'text-danger'}`} to="/">Home</Link></li>
                    <li><Link onClick={toggleNav} className={`${'/book' === location.pathname && 'text-danger'}`} to="/book">Book</Link></li>
                    <li><Link onClick={toggleNav} className={`${'/about' === location.pathname && 'text-danger'}`} to="/about">About</Link></li>
                    <li><Link onClick={toggleNav} className={`${'/contact' === location.pathname && 'text-danger'}`} to="/contact">Contact</Link></li>
                    <li><Link onClick={toggleNav} className={`${'/resources' === location.pathname && 'text-danger'}`} to="/resources">Resources</Link></li>
                </ul>
                <Burger />
            </nav>
        </header>
    )
}

export default Navbar;

